module.exports = __webpack_public_path__ + "media/roomBgm.3c1cd6be.mp3";